import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@material-ui/core";
import { useStyles } from "./CardButtonStyles";
import SrButton from "../SrButton";

const CardButtonImage = ({
  label,
  buttonLabel,
  image,
  onClick,
  bgColor,
  color,
  className,
}) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      paddingTop={2}
      paddingBottom={4}
      bgcolor={bgColor}
      color={color}
      className={className}
    >
      <img src={image} alt={label} />
      <Typography className={classes.label}>{label}</Typography>
      <SrButton color="primary" variant="contained" onClick={onClick}>
        {buttonLabel}
      </SrButton>
    </Box>
  );
};

CardButtonImage.propTypes = {
  label: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  image: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
  bgColor: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  className: PropTypes.element,
};

CardButtonImage.defaultProps = {
  className: null,
};

export default CardButtonImage;
